<template>
  <!--更换验证手机号-身份验证-->
  <el-dialog
    title="标记督学信息"
    :visible.sync="isShowDuxueFlagDialog"
    width="750px"
    custom-class="MyDialog"
    append-to-body
    @close="close"
    >
    <el-form ref="duxueForm" :model="fromData" :rules="rules" label-width="110px">
      <el-form-item label="督学状态：" prop="supervisorStatus">
        <el-radio-group v-model="fromData.supervisorStatus">
          <el-radio v-for="item in duxueStatusList" :key="item.id"
          :label="item.id">{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <p v-if="fromData.supervisorStatus==6158005" class="tips">选择不督学后，系统会自动解除学员和分析师的关系，后续该学员学情跟进，可以前往"大模型数据分析服务系统 - 未督学学员"页面查看</p>
      <el-form-item label="分析师：" prop="teacherIds" v-if="fromData.supervisorStatus && fromData.supervisorStatus != 6158001 && fromData.supervisorStatus!=6158005">
        <el-col :span="22">
          <el-select v-model="fromData.teacherIds" multiple placeholder="请选择分析师"
          @change="teacherIdsChange"
          style="width: 100%;">
            <el-option
              v-for="(item,index) in teacherList"
              :value="item.teacherId"
              :label="item.teacherName"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-tooltip
            placement="top-end"
            content='不督学学员的学情数据，可前往"大模型数据分析服务系统-未督学学员页面"查看'
          >
            <i class="el-icon-question" :style="{ color: '#4A83E8',fontSize:'16px' }"></i>
          </el-tooltip>
        </el-col>
      </el-form-item>
      <el-form-item label="督学有效期：" prop="time" v-if="fromData.supervisorStatus==6158002 || fromData.supervisorStatus==6158003">
        <el-col :span="22">
          <el-date-picker
          style="width: 100%;"
              v-model="fromData.time"
              type="daterange"
              range-separator="至"
              :unlink-panels="true"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="changeTime"
              clearable
            >
            </el-date-picker>
        </el-col>
        <el-col :span="2">
          <el-tooltip
            placement="top-end"
            content='督学结束时间的次日，客户督学状态自动变更为“督学到期”'
          >
            <i class="el-icon-question" :style="{ color: '#4A83E8',fontSize:'16px' }"></i>
          </el-tooltip>
        </el-col>
      </el-form-item>
      <el-form-item label="督学门店：" prop="supervisorShop" v-if="fromData.supervisorStatus && fromData.supervisorStatus != 6158005 && supervisorShopList.length > 0">
        <el-col :span="22">
          <el-select v-model="fromData.supervisorShop" placeholder="请选择督学门店" class="store-select" multiple :multiple-limit="5">
            <el-option 
              v-for="item in supervisorShopList" 
              :key="item.storeId" 
              :label="`${item.detail}`" 
              :value="item.storeId">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="备注：">
        <el-col :span="22">
          <el-input type="textarea" maxlength="100" v-model="fromData.supervisorRemark"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div v-if="!datas.accountId" style="max-height: 300px; overflow: auto">
      <MyTable :titleData="allocatedCustomer_title" :tableData="studentInfo">
      </MyTable>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitChange">{{ '确定' }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDictionaryList,updateStudentSupervisor  } from '@/api/basicApi';
import { getStudentInfoByStudentIds, queryAgentOpeningStoreList } from "@/api/OrderManage";
import { getCheckTeachers } from "@/api/ShiTin";
import MyTable from "@/components/table.vue";
import moment from "moment";
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value || !value[0] || !value[1]) {
        return callback(new Error('请选择督学到期时间'));
      }else{
        callback();
      }
    };
    var checkSupervisorShop = (rule, value, callback) => {
      if (this.fromData.supervisorStatus != 6158005 && (!value || (Array.isArray(value) && value.length === 0))) {
        return callback(new Error('请选择督学门店'));
      } else {
        callback();
      }
    };
    return {
      fromData: {
        supervisorStatus: "",
        teacherIds: [],
        time:[],
        supervisorRemark:'',
        supervisorShop:[],
      },
      allocatedCustomer_result:{},
      studentInfo:[],
      allocatedCustomer_title: [
        {
          label: "姓名",
          prop: "studentName",
          key: "studentId",
          width: 160,
          type: "colorText",
          noUrl: true,
        },
        {
          label: "阶段年级",
          prop: "stageGradeDesc",
          key: "stageGradeDesc",
          width: 160,
        },
        {
          label: "学习中心账号",
          prop: "accountUser",
          key: "accountUser",
          width: 160,
        },
        {
          label: "服务人员",
          prop: "serverPeople",
          key: "serverPeople",
          width: 160,
        },
      ],
      duxueStatusList:[],
      teacherList:[],
      supervisorShopList:[],
      rules: {
          teacherIds: [
            { required: true, message: '请选择分析师', trigger: 'change' }
          ],
          time: [
            { validator:checkAge,required: true, trigger: 'change' }
          ],
          supervisorStatus: [
            { required: true, message: '请选择状态', trigger: 'change' }
          ],
          supervisorShop: [
            { required: true, validator: checkSupervisorShop, trigger: 'change' }
          ],
      },
      isStateNum:1,
      isSendCode: false,
      codeCountDown: -1,
      pickerOptions:{
        shortcuts: [{
          text: '7天',
          onClick(picker) {
            console.log(picker.minVisibleDate,9999)
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '1个月',
          onClick(picker) {
            console.log(moment(),moment(picker.minVisibleDate),999)
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(1,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3个月',
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(3,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '6个月',
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(6,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '12个月',
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(12,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate:(time)=>{
          let minTime = new Date('2022-01-01').getTime()
          return minTime>time.getTime()?true:false;
        }
      }
    }
  },
  props: {
    datas: {
      type: Object,
      default: () => {},
    },
    isShowDuxueFlagDialog: {
      type: Boolean,
      default: false,
    },
    isShowOpen: {
      type: Boolean,
      default: false,
    },
    allocatedCustomers:{
      type: Array,
      default: () => {
        return []
      }
    },
  },
  watch: {
    isShowOpen: {
      handler(newVal, oldVal) {
        this.changePhoneVerifyDialog = newVal
      },
      immediate: true
    },
  },
  components:{
    MyTable,
  },
  mounted(){
    this.initData()
    this.getStudentInfoByStudentIds()
    if(this.datas && this.datas.accountId){
      const {supervisorStatus,teacherIds,supervisorStartTime,supervisorEndTime,supervisorRemark,storeIds = []} = this.datas
      this.fromData = {
        supervisorStatus: supervisorStatus==6158001?'':(supervisorStatus || ''),
        teacherIds: teacherIds || [],
        time: [supervisorStartTime||'',supervisorEndTime||''],
        supervisorStartTime:supervisorStartTime || '',
        supervisorEndTime: supervisorEndTime || '',
        supervisorRemark: supervisorRemark || '',
        supervisorShop: storeIds || [],
      }
      if(teacherIds){
        this.teacherIdsChange(teacherIds)
      }
    }
  },
  methods: {
    async initData() {
      await getDictionaryList({ typeId: "6158" }).then(ret => {
        if (ret.code === 0) {
          this.duxueStatusList = ret.data.filter(item=> {
            return item.id != 6158001
          });
        }
      });
      await getCheckTeachers({
        accountStatus: 6026003,
      }).then((res) => {
        if (res.code === 0) {
          this.teacherList = res.data || [];
        }
      });
      queryAgentOpeningStoreList({}).then((res) => {
        if (res.code === 0) {
          this.supervisorShopList = res.data || [];
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },
    changeTime(value) {
      if (value && value.length > 1) {
        this.fromData.supervisorStartTime = value[0];
        this.fromData.supervisorEndTime = value[1];
      } else {
        this.fromData.supervisorStartTime = "";
        this.fromData.supervisorEndTime = "";
      }
    },
    teacherIdsChange(data){

    },
    codeTimeKeep() {
      this.codeTimer = setInterval(() => {
        if (this.codeCountDown < 0) {
          clearInterval(this.codeTimer);
          return;
        }
        this.codeCountDown -= 1;
      }, 1000);
    },
    resetTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
      }
      this.codeCountDown = -1;
      this.isSendCode = false;
    },
    data1Change(data1,data2){
      console.log(data1,data2)
    },
    data2Change(){

    },
    submitChange() {
      this.updateStudentSupervisor();
    },
    getStudentInfoByStudentIds() {
      let userList = this.allocatedCustomers
      if(this.datas && this.datas.studentId){
        userList = [this.datas]
      }
      let ids = [];
      let stu_ids = [];
      userList.forEach((item) => {
        ids.push(item.studentId);
        stu_ids.push(item.studentId);
      });
      this.allocatedCustomer_result["ids"] = stu_ids;
      getStudentInfoByStudentIds(stu_ids).then((res) => {
        console.log(res);
        if (res.code === 0) {
          let options = res.data;
          options.map((item) => {
            item["stageGradeDesc"] =
              item["stageName"] + "/" + item["gradeName"];
          });
          console.log(options);
          this.studentInfo = options;
        }
      });
    },
    // 提交信息
    updateStudentSupervisor() {
      this.$refs.duxueForm.validate((valid) => {
        if(!valid){
          return
        }
        let params = {
          studentIds: this.allocatedCustomer_result.ids,
          supervisorStatus:this.fromData.supervisorStatus,
          teacherIds: this.fromData.teacherIds,
          supervisorStartTime:this.fromData.supervisorStartTime,
          supervisorEndTime:this.fromData.supervisorEndTime,
          supervisorRemark:this.fromData.supervisorRemark,
          storeIds:this.fromData.supervisorShop,
        }
        updateStudentSupervisor(params).then(res=>{
          if(res.code === 0){
            this.$message.success('标记成功')
            this.close('flash')
          }else{
            this.$message.error(res.message || '操作失败');
          }
         })
      })
    },
    close(flash) {
      console.log(flash)
      this.changePhoneVerifyDialog = false;
      this.$emit('closeDuxueFlagDialog',flash);
    }
  },
}
</script>

<style scoped lang="scss">
.tips{
  margin: -20px 100px 10px;
  color: #e6a23c;
}
.MyDialog{
  .store-select{
    width: 100%;
  }
}
</style>